import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { fetchInstanceData } from './initialization.thunks'
import { saveInstanceToStorage } from './initialization.helpers';

interface InitializationState {
  instance: string;
  isLoading: boolean;
  error: string | null;
  isInitialized: boolean;
}

const initialState: InitializationState = {
  instance: '',
  isLoading: false,
  error: null,
  isInitialized: false,
};

const initializationSlice = createSlice({
  name: 'initialization',
  initialState,
  reducers: {
    resetInitialization: (state) => {
      state.instance = '';
      state.isLoading = false;
      state.error = null;
      state.isInitialized = false;
    },
    clearError: (state) => {
      state.error = null;
    },
    setInstance: (state, action: PayloadAction<string>) => {
      state.instance = action.payload;
      state.isInitialized = true;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchInstanceData.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(fetchInstanceData.fulfilled, (state, action) => {
        state.isLoading = false;
        state.instance = action.payload;
        state.isInitialized = true;
        state.error = null;
        saveInstanceToStorage(action.payload);
      })
      .addCase(fetchInstanceData.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload as string;
        state.isInitialized = false;
      });
  },
});

export const { resetInitialization, clearError, setInstance } = initializationSlice.actions;
export default initializationSlice.reducer;
